<style src="./Styles.scss" lang="scss"></style>
<template>
  <div
    class="global-daily-resume-credit wrapper wrapper-content animated fadeInRight"
  >
    <div class="ibox float-e-margins">
      <form class="form-horizontal" @submit.prevent="generateReport">
        <div class="col-md-2">
          <div class="input-group col-md-12">
            <label>Label</label>
            <tags-input
              v-model="searchForm.labels"
              placeholder="Insira uma label"
              :existing-tags="existentLabels"
              :typeahead="true"
              only-existing-tags
            ></tags-input>
          </div>
        </div>
        <div class="col-md-3">
          <div class="input-group col-md-6">
            <label>Data de inicio</label>
            <input
              type="date"
              class="form-control"
              v-model="searchForm.startDate"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="input-group col-md-6">
            <label>Data de termino</label>
            <input
              type="date"
              class="form-control"
              v-model="searchForm.endDate"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="input-group col-md-12">
            <label>Nome</label>
            <input
              type="text"
              class="form-control"
              placeholder="Digite um nome"
              v-model="searchForm.name"
            />
          </div>
        </div>
        <br />
        <div class="col-md-2">
          <div class="input-group-btn input-group">
            <button class="btn btn-sm btn-primary" v-if="permissionRead">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="ibox-content mailbox-content">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>Labels</th>
            <th>Data de Abertura</th>
            <th>Data de Fechamento</th>
            <th>Total do sistema</th>
            <th>Total declarado</th>
            <th>Valor final</th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(listItem, listIdx) in accountingReports" :key="listIdx">
            <td>{{ listItem.name || listItem.user.fullName }}</td>
            <td>
              <div
                v-for="(label, index) in listItem.accountingHistory.labels"
                :key="index"
              >
                <LabelInfo :label="label" />
              </div>
            </td>
            <td>{{ listItem.accountingHistory.openedDate | DateBR }}</td>
            <td>{{ listItem.accountingHistory.closedDate | DateBR }}</td>
            <td>
              {{
                listItem.accountingHistory.totalSystemSales | totalToCurrencyBR
              }}
            </td>
            <td>
              {{ listItem.accountingHistory.totalDeclared | totalToCurrencyBR }}
            </td>
            <td>
              {{ listItem.accountingHistory.finalAmount | totalToCurrencyBR }}
            </td>
            <td class="list-command">
              <button
                type="button"
                @click="moreInfo(listItem)"
                class="info-btn"
                v-if="permissionRead"
              >
                <i class="fa fa-ellipsis-h"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import LabelInfo from '../../components/labelInfo/LabelInfo';

export default {
  components: {
    LabelInfo,
  },
  data() {
    return {
      existentLabels: [],
      searchForm: {
        labels: [],
        startDate: '',
        endDate: '',
        name: '',
      },

      accountingReports: [],
    };
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
  },

  computed: {
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'accounting-cash-report',
        'READ',
      );
    },
  },

  mounted() {
    this.loadLabels();
  },

  methods: {
    async loadLabels() {
      const labels = await this.$store.dispatch('LABELS/All');
      const formattedLabels = labels.map(label => {
        return {
          key: label._id,
          value: label.title,
        };
      });
      this.existentLabels = formattedLabels;
    },

    async generateReport() {
      if (!this.permissionRead) {
        return;
      }
      const payload = {
        labels: JSON.stringify(this.searchForm.labels.map(label => label.key)),
      };

      if (this.searchForm.startDate) {
        payload.startDate = this.searchForm.startDate;
      }
      if (this.searchForm.endDate) {
        payload.endDate = this.searchForm.endDate;
      }
      if (this.searchForm.name) {
        payload.name = this.searchForm.name;
      }
      const accountingList = await this.$store.dispatch(
        'ACCOUNTING-CASH/ReportClosed',
        payload,
      );
      this.accountingReports = accountingList;
    },

    moreInfo(item) {
      let routeData = this.$router.resolve({
        name: 'CloseAccountingCashInfo',
        params: { accountingId: item.accountingHistory._id },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>